import { __decorate } from 'tslib';
import * as i0 from '@angular/core';
import { forwardRef, ElementRef, Component, ChangeDetectionStrategy, Optional, Inject, Self, Input, HostBinding, HostListener, ViewEncapsulation, ContentChildren, Directive, NgModule } from '@angular/core';
import { tuiIsNativeFocused, EMPTY_QUERY, tuiQueryListChanges, tuiMoveFocus, tuiIsNativeFocusedIn, tuiSetNativeMouseFocused, tuiIsPresent, tuiIsElement, tuiPure } from '@taiga-ui/cdk';
import * as i3 from '@taiga-ui/core/directives';
import { TUI_TEXTFIELD_WATCHED_CONTROLLER, TEXTFIELD_CONTROLLER_PROVIDER } from '@taiga-ui/core/directives';
import { TUI_OPTION_CONTENT, TUI_DATA_LIST_HOST, TUI_COMMON_ICONS, TUI_NOTHING_FOUND_MESSAGE, tuiAsDataListAccessor } from '@taiga-ui/core/tokens';
import { map } from 'rxjs/operators';
import * as i5 from '@taiga-ui/core/directives/dropdown';
import { TuiDropdownDirective } from '@taiga-ui/core/directives/dropdown';
import { shouldCall } from '@tinkoff/ng-event-plugins';
import * as i1 from '@taiga-ui/core/components/svg';
import { TuiSvgModule } from '@taiga-ui/core/components/svg';
import * as i2 from '@tinkoff/ng-polymorpheus';
import { PolymorpheusModule } from '@tinkoff/ng-polymorpheus';
import * as i1$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i4 from 'rxjs';
const _c0 = ["tuiOption", ""];
function TuiOptionComponent_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r3 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r3, "\n");
  }
}
function TuiOptionComponent_ng_template_1_tui_svg_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "tui-svg", 3);
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("src", ctx_r4.icons.more);
  }
}
function TuiOptionComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
    i0.ɵɵtemplate(1, TuiOptionComponent_ng_template_1_tui_svg_1_Template, 1, 1, "tui-svg", 2);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.dropdown);
  }
}
const _c1 = a0 => ({
  $implicit: a0
});
const _c2 = ["*"];
function TuiDataListComponent_div_2_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const text_r2 = ctx.polymorpheusOutlet;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", text_r2, " ");
  }
}
function TuiDataListComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵtemplate(1, TuiDataListComponent_div_2_ng_container_1_Template, 2, 1, "ng-container", 3);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("polymorpheusOutlet", ctx_r0.emptyContent || i0.ɵɵpipeBind1(2, 1, ctx_r0.defaultEmptyContent$));
  }
}
function shouldFocus({
  currentTarget
}) {
  return !tuiIsNativeFocused(currentTarget);
}
// TODO: Consider all use cases for aria roles
class TuiOptionComponent {
  constructor(content, dataList, el, host, dropdown, icons) {
    this.content = content;
    this.dataList = dataList;
    this.el = el;
    this.host = host;
    this.dropdown = dropdown;
    this.icons = icons;
    /** @deprecated use size on {@link TuiDataListComponent} instead */
    this.size = null;
    this.role = 'option';
    this.disabled = false;
  }
  get active() {
    return !!this.dropdown && !!this.dropdown.dropdownBoxRef;
  }
  onClick() {
    if (this.host && this.value !== undefined) {
      this.host.handleOption(this.value);
    }
  }
  // @bad TODO: Consider aria-activedescendant for proper accessibility implementation
  onMouseMove({
    currentTarget
  }) {
    currentTarget.focus({
      preventScroll: true
    });
  }
  // Preventing focus loss upon focused option removal
  ngOnDestroy() {
    var _a;
    (_a = this.dataList) === null || _a === void 0 ? void 0 : _a.handleFocusLossIfNecessary(this.el.nativeElement);
  }
}
TuiOptionComponent.ɵfac = function TuiOptionComponent_Factory(t) {
  return new (t || TuiOptionComponent)(i0.ɵɵdirectiveInject(TUI_OPTION_CONTENT, 8), i0.ɵɵdirectiveInject(forwardRef(() => TuiDataListComponent), 8), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_DATA_LIST_HOST, 8), i0.ɵɵdirectiveInject(TuiDropdownDirective, 10), i0.ɵɵdirectiveInject(TUI_COMMON_ICONS));
};
TuiOptionComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TuiOptionComponent,
  selectors: [["button", "tuiOption", ""], ["a", "tuiOption", ""]],
  hostAttrs: ["tabIndex", "-1", "type", "button"],
  hostVars: 5,
  hostBindings: function TuiOptionComponent_HostBindings(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵlistener("click", function TuiOptionComponent_click_HostBindingHandler() {
        return ctx.onClick();
      })("mousemove.silent", function TuiOptionComponent_mousemove_silent_HostBindingHandler($event) {
        return ctx.onMouseMove($event);
      });
    }
    if (rf & 2) {
      i0.ɵɵattribute("disabled", ctx.disabled || null)("data-size", ctx.size)("role", ctx.role);
      i0.ɵɵclassProp("_with-dropdown", ctx.active);
    }
  },
  inputs: {
    size: "size",
    role: "role",
    disabled: "disabled",
    value: "value"
  },
  attrs: _c0,
  ngContentSelectors: _c2,
  decls: 3,
  vars: 4,
  consts: [[4, "polymorpheusOutlet", "polymorpheusOutletContext"], ["base", ""], ["class", "t-arrow", 3, "src", 4, "ngIf"], [1, "t-arrow", 3, "src"]],
  template: function TuiOptionComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵtemplate(0, TuiOptionComponent_ng_container_0_Template, 2, 1, "ng-container", 0)(1, TuiOptionComponent_ng_template_1_Template, 2, 1, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor);
    }
    if (rf & 2) {
      const _r2 = i0.ɵɵreference(2);
      i0.ɵɵproperty("polymorpheusOutlet", ctx.content || _r2)("polymorpheusOutletContext", i0.ɵɵpureFunction1(2, _c1, _r2));
    }
  },
  dependencies: [i1.TuiSvgComponent, i2.PolymorpheusOutletDirective, i1$1.NgIf],
  styles: ["[_nghost-%COMP%]{-webkit-appearance:none;-moz-appearance:none;appearance:none;padding:0;border:0;background:none;font-size:inherit;line-height:inherit;transition-property:background;transition-duration:var(--tui-duration, .3s);transition-timing-function:ease-in-out;justify-content:space-between;text-align:left;color:var(--tui-text-01);border-radius:var(--tui-radius-s);outline:none;text-decoration:none;cursor:pointer;background-clip:padding-box}[_nghost-%COMP%]:disabled{opacity:var(--tui-disabled-opacity);cursor:default}[_nghost-%COMP%]:focus, ._with-dropdown[_nghost-%COMP%]{background-color:var(--tui-clear)}[_nghost-%COMP%]   [data-list-size=\"s\"][_nghost-%COMP%], [data-list-size=\"s\"]   [_nghost-%COMP%], [_nghost-%COMP%]   [data-list-size=\"xs\"][_nghost-%COMP%], [data-list-size=\"xs\"]   [_nghost-%COMP%], [data-size=s][data-size=s][_nghost-%COMP%], [data-size=xs][data-size=xs][_nghost-%COMP%]{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-s);min-height:2rem;padding:.3125rem .5rem}[_nghost-%COMP%]   [data-list-size=\"m\"][_nghost-%COMP%], [data-list-size=\"m\"]   [_nghost-%COMP%], [data-size=m][data-size=m][_nghost-%COMP%]{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-s);min-height:2.5rem;padding:.375rem .5rem}[_nghost-%COMP%]   [data-list-size=\"l\"][_nghost-%COMP%], [data-list-size=\"l\"]   [_nghost-%COMP%], [data-size=l][data-size=l][_nghost-%COMP%]{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-m);min-height:2.75rem;padding:.375rem .625rem}.t-arrow[_ngcontent-%COMP%]{margin:0 -.5rem 0 .75rem}"],
  changeDetection: 0
});
__decorate([shouldCall(shouldFocus)], TuiOptionComponent.prototype, "onMouseMove", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// TODO: Consider aria-activedescendant for proper accessibility implementation
class TuiDataListComponent {
  constructor(controller, el, defaultEmptyContent$) {
    var _a;
    this.controller = controller;
    this.el = el;
    this.defaultEmptyContent$ = defaultEmptyContent$;
    this.options = EMPTY_QUERY;
    this.role = 'listbox';
    this.size = ((_a = this.controller) === null || _a === void 0 ? void 0 : _a.size) || 'm';
  }
  get empty$() {
    return tuiQueryListChanges(this.options).pipe(map(({
      length
    }) => !length));
  }
  onFocusIn(relatedTarget, currentTarget) {
    if (!currentTarget.contains(relatedTarget) && !this.origin) {
      this.origin = relatedTarget;
    }
  }
  noop() {}
  onKeyDownArrow(current, step) {
    const {
      elements
    } = this;
    tuiMoveFocus(elements.indexOf(current), elements, step);
  }
  // TODO: Consider aria-activedescendant for proper accessibility implementation
  handleFocusLossIfNecessary(element = this.el.nativeElement) {
    if (this.origin && tuiIsNativeFocusedIn(element)) {
      tuiSetNativeMouseFocused(this.origin, true, true);
    }
  }
  getOptions(includeDisabled = false) {
    return this.options.filter(({
      disabled
    }) => includeDisabled || !disabled).map(({
      value
    }) => value).filter(tuiIsPresent);
  }
  onFocus({
    target
  }, top) {
    if (!tuiIsElement(target)) {
      return;
    }
    const {
      elements
    } = this;
    tuiMoveFocus(top ? -1 : elements.length, elements, top ? 1 : -1);
    this.handleFocusLossIfNecessary(target);
  }
  get elements() {
    return Array.from(this.el.nativeElement.querySelectorAll('[tuiOption]'));
  }
}
TuiDataListComponent.ɵfac = function TuiDataListComponent_Factory(t) {
  return new (t || TuiDataListComponent)(i0.ɵɵdirectiveInject(TUI_TEXTFIELD_WATCHED_CONTROLLER, 8), i0.ɵɵdirectiveInject(ElementRef), i0.ɵɵdirectiveInject(TUI_NOTHING_FOUND_MESSAGE));
};
TuiDataListComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TuiDataListComponent,
  selectors: [["tui-data-list"]],
  contentQueries: function TuiDataListComponent_ContentQueries(rf, ctx, dirIndex) {
    if (rf & 1) {
      i0.ɵɵcontentQuery(dirIndex, TuiOptionComponent, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.options = _t);
    }
  },
  hostVars: 2,
  hostBindings: function TuiDataListComponent_HostBindings(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵlistener("focusin", function TuiDataListComponent_focusin_HostBindingHandler($event) {
        return ctx.onFocusIn($event.relatedTarget, $event.currentTarget);
      })("mousedown.prevent", function TuiDataListComponent_mousedown_prevent_HostBindingHandler() {
        return ctx.noop();
      })("keydown.arrowDown.prevent", function TuiDataListComponent_keydown_arrowDown_prevent_HostBindingHandler($event) {
        return ctx.onKeyDownArrow($event.target, 1);
      })("keydown.arrowUp.prevent", function TuiDataListComponent_keydown_arrowUp_prevent_HostBindingHandler($event) {
        return ctx.onKeyDownArrow($event.target, -1);
      })("wheel.silent.passive", function TuiDataListComponent_wheel_silent_passive_HostBindingHandler() {
        return ctx.handleFocusLossIfNecessary();
      })("mouseleave", function TuiDataListComponent_mouseleave_HostBindingHandler($event) {
        return ctx.handleFocusLossIfNecessary($event.target);
      });
    }
    if (rf & 2) {
      i0.ɵɵattribute("role", ctx.role)("data-list-size", ctx.size);
    }
  },
  inputs: {
    role: "role",
    emptyContent: "emptyContent",
    size: "size"
  },
  features: [i0.ɵɵProvidersFeature([tuiAsDataListAccessor(TuiDataListComponent), TEXTFIELD_CONTROLLER_PROVIDER])],
  ngContentSelectors: _c2,
  decls: 5,
  vars: 3,
  consts: [["tabindex", "0", 1, "t-trap", 3, "focusin"], ["class", "t-empty", 4, "ngIf"], [1, "t-empty"], [4, "polymorpheusOutlet"]],
  template: function TuiDataListComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵelementStart(0, "div", 0);
      i0.ɵɵlistener("focusin", function TuiDataListComponent_Template_div_focusin_0_listener($event) {
        return ctx.onFocus($event, true);
      });
      i0.ɵɵelementEnd();
      i0.ɵɵprojection(1);
      i0.ɵɵtemplate(2, TuiDataListComponent_div_2_Template, 3, 3, "div", 1);
      i0.ɵɵpipe(3, "async");
      i0.ɵɵelementStart(4, "div", 0);
      i0.ɵɵlistener("focusin", function TuiDataListComponent_Template_div_focusin_4_listener($event) {
        return ctx.onFocus($event, false);
      });
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵadvance(2);
      i0.ɵɵproperty("ngIf", i0.ɵɵpipeBind1(3, 1, ctx.empty$));
    }
  },
  dependencies: [i1$1.NgIf, i2.PolymorpheusOutletDirective, i1$1.AsyncPipe],
  styles: ["tui-data-list{--tui-data-list-padding: .25rem;--tui-data-list-margin: .0625rem;display:flex;font:var(--tui-font-text-m);flex-direction:column;padding:calc(var(--tui-data-list-padding) - var(--tui-data-list-margin)) var(--tui-data-list-padding);color:var(--tui-text-03)}tui-data-list:focus-within .t-trap{display:none}tui-data-list:focus-within [tuiOption]._with-dropdown:not(:focus){background-color:transparent}tui-data-list[data-list-size=s]{--tui-data-list-margin: 0rem}tui-data-list[data-list-size=s]>.t-empty{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-s);min-height:2rem;padding:.3125rem .5rem}tui-data-list[data-list-size=m]>.t-empty{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-s);min-height:2.5rem;padding:.375rem .5rem}tui-data-list[data-list-size=l]{--tui-data-list-padding: .375rem;--tui-data-list-margin: .125rem}tui-data-list[data-list-size=l]>.t-empty{display:flex;align-items:center;box-sizing:border-box;margin:var(--tui-data-list-margin) 0;font:var(--tui-font-text-m);min-height:2.75rem;padding:.375rem .625rem}tui-opt-group{position:relative;display:flex;font:var(--tui-font-text-xs);color:var(--tui-text-02);flex-direction:column;line-height:1rem}tui-data-list[data-list-size=l] tui-opt-group{font:var(--tui-font-text-s);line-height:1.25rem}tui-data-list[data-list-size=l] tui-opt-group:before{padding-left:.625rem;padding-right:.625rem}tui-data-list[data-list-size=l] tui-opt-group:after{left:.625rem;right:.625rem}tui-opt-group:empty:before,tui-opt-group:empty:after{display:none}tui-opt-group:before{content:attr(data-label);padding:var(--tui-data-list-padding) .5rem var(--tui-data-list-padding);margin:var(--tui-data-list-margin) 0;white-space:normal;word-break:break-word}tui-opt-group:after{position:absolute;left:.5rem;right:.5rem;top:var(--tui-data-list-padding);height:1px;background:var(--tui-base-03)}tui-opt-group:not(:empty)~tui-opt-group:before{padding-top:calc(.75rem + var(--tui-data-list-padding))}tui-opt-group:not(:empty)~tui-opt-group[data-label=\"\"]:before,tui-opt-group:not(:empty)~tui-opt-group:not([data-label]):before{padding:var(--tui-data-list-padding) 0}tui-opt-group:not(:empty)~tui-opt-group:after{content:\"\"}tui-opt-group[data-label=\"\"]:before,tui-opt-group:not([data-label]):before{padding:0;margin:0}\n"],
  encapsulation: 2,
  changeDetection: 0
});
__decorate([tuiPure], TuiDataListComponent.prototype, "empty$", null);
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiDataListDirective = /*#__PURE__*/(() => {
  class TuiDataListDirective {}
  TuiDataListDirective.ɵfac = function TuiDataListDirective_Factory(t) {
    return new (t || TuiDataListDirective)();
  };
  TuiDataListDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiDataListDirective,
    selectors: [["ng-template", "tuiDataList", ""]]
  });
  return TuiDataListDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
function tuiAsDataList(useExisting) {
  return {
    provide: TuiDataListDirective,
    useExisting
  };
}
let TuiOptGroupDirective = /*#__PURE__*/(() => {
  class TuiOptGroupDirective {}
  TuiOptGroupDirective.ɵfac = function TuiOptGroupDirective_Factory(t) {
    return new (t || TuiOptGroupDirective)();
  };
  TuiOptGroupDirective.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
    type: TuiOptGroupDirective,
    selectors: [["tui-opt-group"]],
    hostAttrs: ["role", "group"],
    hostVars: 1,
    hostBindings: function TuiOptGroupDirective_HostBindings(rf, ctx) {
      if (rf & 2) {
        i0.ɵɵattribute("data-label", ctx.label);
      }
    },
    inputs: {
      label: "label"
    }
  });
  return TuiOptGroupDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let TuiDataListModule = /*#__PURE__*/(() => {
  class TuiDataListModule {}
  TuiDataListModule.ɵfac = function TuiDataListModule_Factory(t) {
    return new (t || TuiDataListModule)();
  };
  TuiDataListModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: TuiDataListModule
  });
  TuiDataListModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [[CommonModule, TuiSvgModule, PolymorpheusModule]]
  });
  return TuiDataListModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiDataListComponent, TuiDataListDirective, TuiDataListModule, TuiOptGroupDirective, TuiOptionComponent, tuiAsDataList };
